// Nigeria is the platform's home country. Phone pickers open on it and list it
// first, new records default to its dialling code, and country dropdowns put it
// at the top of their options.
export const DEFAULT_COUNTRY = {
  name: 'Nigeria',
  isoCode: 'ng',
  dialCode: '+234',
} as const;

/** `react-phone-input-2` country codes pinned above the alphabetical list. */
export const PREFERRED_PHONE_COUNTRIES: string[] = [DEFAULT_COUNTRY.isoCode];

/**
 * Returns a copy of `items` with the default country moved to the front. The
 * rest keep their original order, and a list without it is returned unchanged.
 */
export const withDefaultCountryFirst = <T>(
  items: T[],
  getName: (item: T) => string | null | undefined,
): T[] => {
  const isDefault = (item: T) =>
    getName(item)?.trim().toLowerCase() === DEFAULT_COUNTRY.name.toLowerCase();

  return [...items.filter(isDefault), ...items.filter((item) => !isDefault(item))];
};
